import React, { useState } from 'react';

const HelpModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    // Close the modal if the click is outside the modal content
    if (event.target.id === 'videoModal') {
      closeModal();
    }
  };

  let helpIcon = require("images/lite/icons/question-circle.svg");
  helpIcon = <img className="lite-nav-icon filter-grey" src={`/datapulse${helpIcon}`} />;

  let xIcon = require("images/lite/icons/x-close.svg");
  xIcon = (
    <img className="close-icon" alt="remove" src={`/datapulse${xIcon}`} />
  );



  return (
    <>
      <div  className="help-video-icon" onClick={openModal}>
        {helpIcon}
      </div>

      {isOpen && (
        <div id="videoModal" className="help-modal" style={{ display: 'block' }} onClick={handleClickOutside}>
          <div className="help-modal-content">
          <button type="button" className="close-button-help-modal filter-grey" onClick={closeModal}>{xIcon}</button>
            {/* <span className="help-close" onClick={closeModal}>&times;</span> */}
            <iframe
              id="helpVideo"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/jpb3I9NZ5WM?si=TNGi-RMHz4ao_mIE" 
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpModal;
